import axios from 'axios';
import store from '../redux/store';
import { LOGOUT } from '../redux/actions/types';

const api = axios.create({
  /** baseURL: 'https://cboxda.canadaeast.cloudapp.azure.com/', */
  /** baseURL: 'https://cboxda.converjit.com/', */
  /** baseURL: 'https://cboxda1.converjit.com/', */
  /** baseURL: 'https://cboxqa.converjit.com/', */
  /** baseURL: 'https://cbox.converjit.com/', */
  /** baseURL: 'https://localhost/', */
  // baseURL: 'https://localhost/',
  headers: {
    'Content-Type': 'application/json',
  },
});
/**
 intercept any error responses from the api
 and check if the token is no longer valid.
 ie. Token has expired or user is no longer
 authenticated.
 logout the user if the token has expired
**/

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 400 && err.response.data && err.response.data.errors && err.response.data.errors.includes('cookie Authentication must not be null')) {
      store.dispatch({ type: LOGOUT });
    }
    return Promise.reject(err);
  }
);

export default api;
